module.exports = __webpack_public_path__ + "static/media/cowboy-hat-face-svgrepo-com.821955fc.svg";